import React from 'react'
import './ModulePanel.sass'

function ModulePanel({ title, buttons = null, children, className = '' }) {
  return (
    <div className={['ModulePanel', className].filter(Boolean).join(' ')}>
      <div className="Title">
        {title} {buttons && <div className="Buttons">{buttons}</div>}
      </div>
      <div className="Content">{children}</div>
    </div>
  )
}

export default ModulePanel
